import React, { FunctionComponent } from 'react';
import styles from './circle-feature-card.module.scss';

export interface ICircleFeatureCardProps {
  data: {
    ico: string;
    content: string;
  };
  isVertical: boolean;
}

export const CircleFeatureCard: FunctionComponent<ICircleFeatureCardProps> = props => {
  return (
    <div
      className={`${
        props.isVertical ? styles.circleVertical : styles.circleHorizontal
      }`}
    >
      <div className={styles.circleItem}>
        <i className={'material-icons'}>{props.data.ico}</i>
      </div>
      <div
        className={props.isVertical ? styles.circleContent : ''}
        dangerouslySetInnerHTML={{ __html: props.data.content }}
      ></div>
    </div>
  );
};
